import { getSavedItemsResetFromStart } from "../../../modules/savedItems/actions";
import { SAVED_ITEMS_SDK_FAILURE } from "../../../modules/savedItems/constants";
import { ServiceError } from "../../../../services/errors";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";

const getSavedItems = () => async dispatch => {
  const { pageLoadGetItemsRetriesBackoff: retryBackoffs } =
    clientConfigurationProvider();

  let savedItems;
  try {
    savedItems = await dispatch(getSavedItemsResetFromStart({ retryBackoffs }));
  } catch (e) {
    if (!(e instanceof ServiceError)) {
      throw e;
    }
    dispatch({ type: SAVED_ITEMS_SDK_FAILURE });

    return;
  }

  return savedItems;
};

export default getSavedItems;
